module.exports = __webpack_public_path__ + "static/media/background-icon.b5947c27.svg";